<template>
    <!-- The base card on the report designs' page grid: a light gray title,
         an optional action beside it, and banded rows. Settings sections, the
         run form and other report panels share it so they read as one set. -->
    <section :class="REPORT_CARD_CLASS">
        <div class="mb-6 flex items-start justify-between gap-2">
            <h2 :class="REPORT_CARD_TITLE_CLASS">
                {{ title }}
            </h2>

            <slot name="actions"></slot>
        </div>

        <!-- `columns: 2` sets the rows side by side; otherwise one banded row
             each. -->
        <div    :class="columns > 1
                    ? 'grid grid-cols-1 gap-x-6 sm:grid-cols-2'
                    : 'report-settings-card-rows'">
            <slot></slot>
        </div>
    </section>
</template>

<style>
/* Rows alternate a light gray band, as in the designs. Opt-in (the row adds
   .report-settings-band) so an input never sits on a gray strip. Unscoped
   because the rows are the roots of child components. */
.report-settings-card-rows > .report-settings-band:nth-child(odd) {
    background-color: rgb(249 250 251);
}
</style>

<script>
// Exported for panels that need the card look on an element they already own
// (the run form's date and point cards).
export const REPORT_CARD_CLASS = 'rounded-lg border border-gray-200 bg-white p-4 shadow-sm sm:p-6'
export const REPORT_CARD_TITLE_CLASS = 'm-0 p-0 text-left text-lg font-normal text-gray-500'
// A row inside the card: banded when it is a toggle or a read-only line.
export const REPORT_CARD_ROW_CLASS = 'report-settings-band flex items-center gap-3 rounded-md px-2 py-3'

export default {
    name: "ReportCard",
    props: {
        title: {
            type: String,
            required: true,
        },
        // Rows per line.
        columns: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            REPORT_CARD_CLASS,
            REPORT_CARD_TITLE_CLASS,
        }
    },
}
</script>
